import { webApi, getCsrfToken } from "../api";

export function getContactInquiries() {
  // Admin list
  return webApi.get(`/admin/contact`);
}

export function getContactInquiry(id: string | number) {
  return webApi.get(`/admin/contact/${id}`);
}

export async function respondToInquiry(id: string | number, payload: any) {
  await getCsrfToken();
  // Backend uses PUT to update the inquiry with a response
  return webApi.put(`/admin/contact/${id}`, payload);
}

export async function deleteInquiry(id: string | number) {
  await getCsrfToken();
  return webApi.delete(`/admin/contact/${id}`);
}

export default {
  getContactInquiries,
  getContactInquiry,
  respondToInquiry,
  deleteInquiry,
};
